// extracted by mini-css-extract-plugin
var _1 = "MainBanner_todayMainBanner__tdLSb";
var _2 = "MainBanner_todayMainBanner__description__5Jw8P";
var _3 = "MainBanner_todayMainBanner__imageContainer__DFHf1";
var _4 = "MainBanner_todayMainBanner__title__PZwSL";
var _5 = "MainBanner_todayMainBanner__titleContainer__cnhoQ";
export { _1 as "todayMainBanner", _2 as "todayMainBanner__description", _3 as "todayMainBanner__imageContainer", _4 as "todayMainBanner__title", _5 as "todayMainBanner__titleContainer" }
